//링크이동
export function moveToLink(url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: url,
        },
      }),
    );
  }
}

//링크이동
export function moveToLinkDetail(url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=shop-main&url=${url}`,
        },
      }),
    );
  }
}

export function moveToLinkNaver(url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
        },
      }),
    );
  }
}

export function moveToLinkWebviewNaver(url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToWebView',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
        },
      }),
    );
  }
}

//주소공유?
export function shareUrl(url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'shareUrl',
        targetFuncParams: { url: url },
      }),
    );
  }
}

//공유?
export function onShopShare(title, mainImage, url) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onShopShare',
        targetFuncParams: { title: title, mainImage: mainImage, url: url },
      }),
    );
  }
}

export function onSignInInducement() {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onSignInInducement',
      }),
    );
  }
}

//링크 새 웹뷰에
export function onLink(string) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToWebView',
        targetFuncParams: { url: string },
      }),
    );
  }
}

//프로필 편집
export function goProfile(userId) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=editMyProfile&ownerUserId=${userId}`,
        },
      }),
    );
  }
}

//유저 데이터 가져오기
export function getUserProfile() {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'getUserData',
      }),
    );
  }
}

//클로즈함수 테스트해야됨
export function onClose(payInfo) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onClose',
      }),
    );
  }
}

//함수 실행
export function goFunc(payInfo) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'returnMyPay',
        targetFuncParams: { payInfo: JSON.stringify(payInfo) },
      }),
    );
  }
}

//스택날리기
export function goBack() {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'goBack',
      }),
    );
  }
}

// 토스트 팝업 출력
export function getToast(val) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'getToast',
        targetFuncParams: val,
      }),
    );
  }
}

//리뷰 더보기 눌렀을때
export function goReivewPlus() {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: 'aboutfishing://aboutfishing.com/?page=community&type=review',
        },
      }),
    );
  }
}

//회원가입 했을때
export function registerComplete(mobile) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'shop_join_done',
          eventType: {
            os: mobile,
          },
        },
      }),
    );
  }
}
//장바구니 버튼 눌러 장바구니 페이지로 이동
export function goCart(mobile, productId) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'cart',
          eventType: {
            os: mobile,
            productId: productId,
          },
        },
      }),
    );
  }
}
//장바구니에서 주문하기 버튼으로 주문서 페이지 이동
export function goOrder(mobile) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase_step_1',
          eventType: {
            os: mobile,
          },
        },
      }),
    );
  }
}

//결제 완료 시점
export function completePurchase(mobile, total, orderId, member, purchase_type) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase_done',
          eventType: {
            os: mobile,
            af_revenue: total,
            af_currency: 'KRW',
            af_order_id: orderId,
            membership_type: member,
            purchase_done_type: purchase_type,
          },
        },
      }),
    );
  }
}

//장바구니 삭제
export function deleteCartApp(mobile, productId) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'delete_cart_item',
          eventType: {
            os: mobile,
            product_id: productId,
          },
        },
      }),
    );
  }
}

//앱스플라이어 이벤트
export function postEvent(mobile, price, items, member, purchaseType) {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase',
          eventType: {
            os: mobile,
            value: price,
            currency: 'KRW',
            items: items,
            membership_type: member,
            purchase_done_type: purchaseType,
          },
          // af_revenue: price,
          // currency: 'KRW',
          // af_order_id: product,
        },
      }),
    );
  }
}

export const RNPostMessage = (targetFuncName, params) => {
  // 리액트 네이티브로 postMessage 전송
  if (!window.ReactNativeWebView) return;
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      targetFunc: `${targetFuncName}`,
      targetFuncParams: params,
    }),
  );
};

export const sendSetAppsflyerEvent = ({ eventName, eventType }) => {
  RNPostMessage(
    'setAppsflyerEvent',
    JSON.stringify({
      eventName,
      eventType,
    }),
  );
};

export const sendSetGTMAppsflyerEventEcommerce = ({ eventName, eventType }) => {
  RNPostMessage(
    'setAppsflyerEvent',
    JSON.stringify({
      eventName,
      eventType: { ecommerce: eventType },
    }),
  );
};
export const sendSetGTMAppsflyerEventEventInfo = ({ eventName, eventType }) => {
  RNPostMessage(
    'setAppsflyerEvent',
    JSON.stringify({
      eventName,
      eventType: { event_info: eventType },
    }),
  );
};

/*
interface AppsflyerEventType {
  af_order_id?: number
  af_price?: number
  
  // 쇼핑 관련 이벤트 타입 - 현재는 사용X. 추후 수정 예정
  type?: string
  section_type?: string
  section_position?: number
  item?: string
  
  // 페이지뷰 이벤트 타입
  name?: string
  class?: string
}
 */

// interface SendSetAppsflyerEvent {
//   eventName: string
//   eventType: AppsflyerEventType | object
// }
